/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Swap_Scope_TodayInputs */

const en_us2_workout_swap_scope_today = /** @type {(inputs: Workout_Swap_Scope_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Just today`)
};

const pt_br2_workout_swap_scope_today = /** @type {(inputs: Workout_Swap_Scope_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Só hoje`)
};

const es_419_workout_swap_scope_today = /** @type {(inputs: Workout_Swap_Scope_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo hoy`)
};

const pt_pt2_workout_swap_scope_today = /** @type {(inputs: Workout_Swap_Scope_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Só hoje`)
};

const fr_fr2_workout_swap_scope_today = /** @type {(inputs: Workout_Swap_Scope_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juste aujourd'hui`)
};

const de_de2_workout_swap_scope_today = /** @type {(inputs: Workout_Swap_Scope_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur heute`)
};

const it_it2_workout_swap_scope_today = /** @type {(inputs: Workout_Swap_Scope_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo oggi`)
};

/**
* | output |
* | --- |
* | "Just today" |
*
* @param {Workout_Swap_Scope_TodayInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_swap_scope_today = /** @type {((inputs?: Workout_Swap_Scope_TodayInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Swap_Scope_TodayInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_swap_scope_today(inputs)
	if (locale === "es-419") return es_419_workout_swap_scope_today(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_swap_scope_today(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_swap_scope_today(inputs)
	if (locale === "de-DE") return de_de2_workout_swap_scope_today(inputs)
	if (locale === "it-IT") return it_it2_workout_swap_scope_today(inputs)
	return en_us2_workout_swap_scope_today(inputs)
});
export { workout_swap_scope_today as "workout-swap.scope_today" }